// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ludicolo: PokeData = {
  "id": 272,
  "name": "ludicolo",
  "height": 15,
  "weight": 550,
  "base_experience": 216,
  "types": [
    PokeType.WATER,
    PokeType.GRASS
  ],
  "api_moves": [
    "growl",
    "mist",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "absorb",
    "mega-drain",
    "fury-swipes",
    "flail",
    "giga-drain",
    "rain-dance",
    "fake-out",
    "nature-power",
    "knock-off",
    "teeter-dance",
    "astonish",
    "energy-ball",
    "zen-headbutt"
  ],
  "moves": [
    "growl",
    "hydro-pump",
    "bubble-beam",
    "rain-dance",
    "energy-ball",
    "zen-headbutt",
    "grassy-terrain",
    "bullet-seed",
    "life-dew",
    "wood-hammer",
    "power-whip",
    "flower-rush",
    "synthesis"
  ],
  "evolution_chain": {
    "id": 136,
    "item": null,
    "species": [
      {
        "name": "lotad",
        "order": 295,
        "types": [
          PokeType.WATER,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lombre",
        "order": 296,
        "types": [
          PokeType.WATER,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 270,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 14,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "ludicolo",
        "order": 297,
        "types": [
          PokeType.WATER,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 271,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "water-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 136,
    "speed": 115,
    "ability_power": 148
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
